module.exports = __webpack_public_path__ + "dotpay.png?69b0e0cefa7f6ab33cfbfa5381f7841c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/dotpay.png
// module id = oT87
// module chunks = 50